export default __webpack_public_path__ + "static/media/NotoSans-SemiBold.3334e733.ttf";